import { Component } from '@angular/core';
import { WorkflowItemKeyDirective } from '@workflow/directives/workflow-item-key/workflow-item-key.directive';

interface VisuomotorischeKoordinationResult {
	zeit: number;
	fehler: number;
}

@Component({
	selector: 'workflow-visuomotorische-koordination-epilog',
	templateUrl: './visuomotorische-koordination-epilog.component.html',
	styleUrls: ['./visuomotorische-koordination-epilog.component.scss']
})
export class VisuomotorischeKoordinationEpilogComponent {
	constructor(public workflowItemKey: WorkflowItemKeyDirective<VisuomotorischeKoordinationResult>) {}
}
